<template>
  <transition name="comment">
    <!-- Your embedded comments code -->
    <div class="fb-comments"
         :data-href="url"
         data-numposts="5">
    </div>
  </transition>
  <!-- Load Facebook SDK for JavaScript -->

</template>

<script>
  export default {
    name: 'vue-facebook-comment',
    props: {
      url: String
    },
    created: function () {
      (function (d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.crossorigin = 'anonymous';
        js.src = '//connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v3.2&appId=547213038750090&autoLogAppEvents=1';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      window.fbAsyncInit = function onSDKInit() {
        window.FB.XFBML.parse()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        if (typeof window.FB !== 'undefined') {
          window.FB.XFBML.parse();
        }
      })
    },
    updated: function () {
    },
    watch: {
      url(to, from) {
        if (to !== from) {
          if (typeof window.FB !== 'undefined') {
            window.FB.XFBML.parse();
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/VueFacebookComment.vue